// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"yi","iconEffect":"yj","ripple":"yk","a":"yl"};